import { Component, OnInit } from '@angular/core';
import { ApplicationConfigurationService } from '@stg-js-ngx-core/oauth';
import { SyncopeService } from './common/services/syncope.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { LoggedInUserDetailsService } from './common/services/logged-in-user-details.service';
import { LanguageService } from './common/services/language.service';
import { RealmsDetailsService } from './common/services/realms-details.service';
import { forkJoin } from 'rxjs';
declare var aaimsCommonService: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'aaims-ui-ngx';
  appLoad: boolean = false;
  loadPages: boolean = false;
  logo: string = '/uix/static/assets/images/aaims-logo.png';
  profileImageUrl: string = '/uix/static/assets/images/genericAvatar.png';
  menuItems: any = [
    {title: 'Home', page: '/home', iconClass: 'fas fa-home'},
    {title: 'Franchise Associate Management', page: '/franchise-associate-management', iconText: 'FAM'},
    {
      title: 'Client Associate Management',
      page: '/client-associate-management/user-management',
      iconText: 'CAM',
      stgSecuredObject: 'Client Associates User Management',
    }
  ];
  profileMenuItems: any = [];
  selfService: boolean = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    private syncopeService: SyncopeService,
    private appConfigService: ApplicationConfigurationService,
    private router: Router,
    private titleService: Title,
    private loggedInUserDetailsService: LoggedInUserDetailsService,
    private languageService: LanguageService,
    private realmsDetailsService: RealmsDetailsService
    ) {
    aaimsCommonService.setRootContext('/uix');
    this.activatedRoute.queryParams.subscribe(params => {
      if(params && params['locale']){
        this.languageService.lang = params['locale'];
      }
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['pageTitle']) {
            routeTitle = route!.snapshot.data['pageTitle'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(`AAIMS | ${title}`);
        }
      });
  }

  loadApp() {
    this.loggedInUserDetailsService.setUserOffset(this.appConfigService.applicationConfig.offset - Date.now());
    if (
      window.location.href.indexOf('selfservice') > -1
    ) {
      this.selfService = true;
      forkJoin([
        this.realmsDetailsService.getRealmsDetails(true),
        this.syncopeService.getConfigurations(true)
      ]).subscribe(res => {
          this.appLoad = true;
        }, (err) => {
          console.error(err);
          this.appLoad = true;
        });
    } else {
      const key = this.appConfigService.applicationConfig.googleMaps.key;
      this.loadScript('https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key);
      this.appLoad = true;
      forkJoin([
        this.syncopeService.getSyncopeUser(),
        this.realmsDetailsService.getRealmsDetails(),
        this.syncopeService.getConfigurations()
      ]).subscribe(res => {
          if (res[0] && res[0].data && res[0].data.plainAttrs) {
            this.syncopeService.syncopeUserObj = res[0].data;
            this.loggedInUserDetailsService.setData(res[0]);
            if (this.syncopeService.syncopeUserObj && this.syncopeService.syncopeUserObj.realm) {
              const userProfileUrl = '/profile/' + this.syncopeService.syncopeUserObj.username;
              this.profileMenuItems = [
                {title: 'My Profile', page: userProfileUrl, iconClass: 'fas fa-user'}
              ]
            }
          }
          this.loadPages = true;
        }, (err) => {
          this.loadPages = true;
          console.error(err);
        });
    }
  };

  loadScript(name: string) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = name;
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}
